import { render, staticRenderFns } from "./Not-Found.vue?vue&type=template&id=19aa1096&scoped=true&"
import script from "./Not-Found.vue?vue&type=script&lang=js&"
export * from "./Not-Found.vue?vue&type=script&lang=js&"
import style0 from "./Not-Found.vue?vue&type=style&index=0&id=19aa1096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa1096",
  null
  
)

export default component.exports